const formationsData = {
  fr: [
    {
      title: "Diplôme d'Ingénieur Civil des Mines de Saint-Etienne",
      date: "2022",
      location: "Saint-Etienne",
      options: ["Majeure informatique (160h)", "Majeure science des données (160h)", "Défi sociétal sur l'IA (160h)", "Toolbox interopérabilité des systèmes informatiques (80h)", "Toolbox réseau (40h)", "Toolbox calcul haute performance (40h)", "Toolbox applications logicielles en entreprise (40h)"],
      projects: ["Pôle communication du BDE et du BDA de l'école en 2019/2020", "Président de l'asso de photo/vidéo de l'école en 2019/2020", "Président de l'asso de voile de l'école en 2019/2020", "Projet de dernière année portant sur le développement d'un plugin en Python pour l'IDE Sublime Text permettant d'utiliser un raccourci clavier pour suivre une URL dans un fichier Turtle"]
    },
    {
      title: "Baccalauréat S option SI spécialité Maths obtenu mention Bien",
      date: "2016",
      location: "Antony",
    },
  ],
  en: [
    {
      title: "Mines Saint-Etienne Civil Engineering Diploma",
      date: "2022",
      location: "Saint-Etienne",
      options: ["Computer science major (160h)", "Data science major (160h)", "courses on artificial intelligence (160h)", "interoperability of IT systems (80h)", "networks (40h)", "high performance calculation (40h)", "software applications (40h)"],
      projects: ["Communications department of the school's student council and art student council in 2019/2020", "President of the school's photo/video association in 2019/2020", "President of the school's sailing association in 2019/2020", "Final-year project involving the development of a plugin in Python for the Sublime Text IDE that allows the use of a keyboard shortcut to follow a URL in a Turtle file."]
    },
    {
      title: "Baccalauréat S option Engineering systems specialising in Maths with distinction",
      date: "2016",
      location: "Antony",
    },
  ]
};
export default formationsData;
